var checkbox = '_9f1gcg9';
var root = '_9f1gcg8';
var visuals = '_9f1gcga';

export { checkbox, root, visuals };
//# sourceMappingURL=manually-labeled-switch.css.js.map
